module.exports = __webpack_public_path__ + "static/media/ProfileImg.913cb166.svg";